module.exports = angular.module('cartographer.common.api.auth', [])

$ = require 'jquery'
_ = require 'underscore'

module.exports.factory 'crtAuth', $DI (
  crtLog
  $q
  $rootScope
  crtConfig
  crtString
  crtStorage
  crtValidate
  crtPromise
  crtHttp
  crtHttpModals
  crtWorkspace
  crtSurvey
  crtSurveyStatus
  crtLayer
  crtMapCollaborationModel
  crtMapPermissionModel
  crtSurveyCollaborationModel
  crtSurveyPermissionModel
) ->
  # The credentials we're using to talk to the server.
  #
  # or(credentials null)
  _credentials = null

  # If we've masqueraded as another user,
  # we use this field to back up the "real credentials".
  #
  # or(credentials null)
  _realCredentials = null

  # -> role[]
  _roles = ->
    # crtLog.debug("_roles", _credentials)
    _credentials?.identity?.roles ? []

  _realRoles = ->
    _realCredentials?.identity?.roles ? _credentials?.identity?.roles ? []

  # -> or(credentials null)
  credentials = ->
    _credentials

  # -> or(credentials null)
  realCredentials = ->
    _realCredentials

  # credentials [boolean] -> credentials
  setCredentials = (creds, backupReal = false) ->
    # crtLog.debug('crtAuth.setCredentials', creds, backupReal)
    if backupReal
      setRealCredentials(_credentials)
    _credentials = creds
    crtHttp.setAccessToken(_credentials?.token)
    setCachedToken(_credentials?.token)
    $rootScope.$broadcast('change:credentials', _credentials)
    if window.Sentry?
      window.Sentry.configureScope (scope) ->
        scope.setUser({
          id         : _credentials?.identity?.userId,
          token      : _credentials?.token
          email      : _credentials?.identity?.email
          screenName : _credentials?.identity?.screenName
          roles      : _credentials?.identity?.roles.join(" ")
        })
    creds

  # credentials -> credentials
  setRealCredentials = (creds) ->
    _realCredentials = creds
    setCachedRealToken(_realCredentials?.token)
    creds

  # -> void
  clearCredentials = ->
    _credentials = null
    _realCredentials = null
    crtHttp.setAccessToken(_credentials?.token)
    setCachedToken(null)
    setCachedRealToken(null)
    return

  # -> void
  restoreCredentials = ->
    _credentials = _realCredentials
    _realCredentials = null
    crtHttp.setAccessToken(_credentials?.token)
    setCachedToken(_credentials?.token)
    setCachedRealToken(null)
    return

  # -> boolean
  isLoggedIn = ->
    ans = !!credentials()
    # crtLog.debug('crtAuth.isLoggedIn', ans)
    ans

  # -> or(string null)
  cachedToken = ->
    ans = crtStorage.get('AuthToken', undefined)
    # crtLog.debug('crtAuth.cachedToken', ans)
    ans

  # -> or(string null)
  cachedRealToken = ->
    ans = crtStorage.get('RealAuthToken', undefined)
    # crtLog.debug('crtAuth.cachedRealToken', ans)
    ans

  # or(string null) -> void
  setCachedToken = (token) ->
    # crtLog.debug('crtAuth.setCachedToken', token)
    if token
      crtStorage.set('AuthToken', token)
    else
      crtStorage.remove('AuthToken')
    token

  # or(string null) -> void
  setCachedRealToken = (token) ->
    # crtLog.debug('crtAuth.setCachedRealToken', token)
    if token
      crtStorage.set('RealAuthToken', token)
    else
      crtStorage.remove('RealAuthToken')
    token

  authError = (message) ->
    return {
      type: "AuthError"
      message
    }

  # boolean -> promiseOf(credentials)
  fetchCredentials = (required = true) ->
    methodName = if required then 'crtAuth.requireCredentials' else 'crtAuth.optionalCredentials'

    # Make sure the credentials are authorized for the current workspace.
    # Otherwise redirect the user to an authorized workspace:
    _checkActive = (credentials) ->
      workspaceId = crtWorkspace.currentWorkspaceId()
      if credentials && workspaceId
        activeRoles = _.filter(credentials.identity.roles, (role) -> /^active:(.*)/.test(role))
        if isActive(workspaceId, credentials.identity.roles)
          credentials
        else if activeRoles.length > 0
          activeWorkspaceId = activeRoles[0].match(/^active:(.*)/)[1]
          if activeWorkspaceId?
            crtWorkspace.read(activeWorkspaceId).then (workspace) ->
              crtWorkspace.changeWorkspace(workspace.subdomain)
        else
          $q.reject("Your account has been disabled, possibly due to a period of inactivity. Please contact support.")
      else
        credentials

    if isLoggedIn()
      # crtLog.debug(methodName, 'logged in', credentials())
      crtPromise.create(credentials()).then(_checkActive)
    else
      # crtLog.debug(methodName, 'logged out')

      restoreReal = ->
        realToken = cachedRealToken()
        if realToken
          crtHttp.get("#{crtConfig.api.rootUrl}/auth/v1/#{realToken}").then(
            (creds) ->
              # crtLog.debug(methodName, 'token checked', creds)
              setRealCredentials(creds)
              creds
            -> null
          )
        else
          crtPromise.create(null)

      restoreEffective = ->
        token = cachedToken()
        if token
          # crtLog.debug(methodName, 'token cached', token)

          crtHttp.get("#{crtConfig.api.rootUrl}/auth/v1/#{token}").then(
            (creds) ->
              # crtLog.debug(methodName, 'token checked', creds)
              setCredentials(creds)
              creds
            ->
              crtLog.debug(methodName, 'token expired')
              if required
                $q.reject(authError('Session expired'))
              else
                null
          ).then(_checkActive)
        else
          # crtLog.debug('crtAuth.requireCredentials', 'no token')
          if required
            crtPromise.reject(authError('Not logged in'))
          else
            crtPromise.create(null)

      restoreReal().then(restoreEffective)

  requireCredentials = ->
    crtLog.debug('crtAuth.requireCredentials start')
    fetchCredentials(true).then(
      (credentials) ->
        crtLog.debug("crtAuth.requireCredentials result", credentials)
        credentials
      (error) ->
        crtLog.warn("crtAuth.requireCredentials error", error)
        throw error
    )

  optionalCredentials = ->
    crtLog.debug('crtAuth.optionalCredentials start')
    fetchCredentials(false).then(
      (credentials) ->
        crtLog.debug("crtAuth.optionalCredentials result", credentials)
        credentials
      (error) ->
        crtLog.warn("crtAuth.optionalCredentials error", error)
        throw error
    )

  # signup -> listOf(validationError)
  _innerValidateSignup = (signup) ->
    crtValidate
    .create(signup)
    .field('firstName',   crtValidate.required("Please enter your first name."))
    .field('lastName',    crtValidate.required("Please enter your last name."))
    .field('email',       crtValidate.email("Please enter a valid email address."))
    .field('screenName',  crtValidate.required("Please enter a screen name."))
    .field('screenName',  crtValidate.optional(crtValidate.lengthGte(4, "Screen names must be between 4 to 50 characters long.")))
    .field('screenName',  crtValidate.optional(crtValidate.lengthLte(50, "Screen names must be between 4 to 50 characters long.")))
    .field('acceptTerms', crtValidate.oneOf([ true ], "You must accept the terms and conditions and privacy policy."))
    .finish()

  # signup -> listOf(validationError)
  validateAnonymousSignup = (signup) ->
    ans = crtValidate
    .create(signup)
    .whole(_innerValidateSignup)
    .finish()
    # crtLog.debug('crtAuth.validateAnonymousSignup', signup, ans)
    ans

  # signup -> listOf(validationError)
  validateWorkshopSignup = (signup) ->
    ans = crtValidate
    .create(signup)
    .whole(_innerValidateSignup)
    .field('password', crtValidate.required("Please choose a password."))
    .field('password', crtValidate.optional(crtValidate.password()))
    .finish()
    # crtLog.debug('crtAuth.validateWorkshopSignup', signup, ans)
    ans

  # signup -> promiseOf(checkedOf(signup))
  submitSignup = (signup) ->
    # crtLog.debug('crtAuth.submitSignup', signup)
    crtHttp.post("#{crtConfig.api.rootUrl}/auth/v1/signup", signup)

  # login -> listOf(validationError)
  validateLogin = (login) ->
    ans = []

    # This validation code has been removed to prevent immediate errors putting people off:
    #
    if !_.isString(login.email) || $.trim(login.email).length == 0
      ans.push { level: "error", field: "email", message: "Enter your email address." }
    # else if !crtString.isEmail(login.email)
    #   ans.push { level: "error", field: "email", message: "Enter your email address." }

    if !_.isString(login.password) || $.trim(login.password).length == 0
      ans.push { level: "error", field: "password", message: "Enter your password for Cartographer." }

    return ans

  # login -> promiseOf(or(loginChallenge, credentials))
  submitLogin = (login) ->
    # crtLog.debug('crtAuth.submitLogin', login)
    crtHttp.post("#{crtConfig.api.rootUrl}/auth/v1/login", login, {
      success: (response) ->
        response
      error: (response) ->
        switch response.status
          when 0
            crtHttpModals.showNetworkProblemModal(response)['finally'](-> $window.location.reload())
            $q.reject(response)
          when 400, 401, 403, 404, 409
            response.data # unpack login challenge from error data returned by crtHttp.post()
          when 413
            crtHttpModals.showDataTooLargeModal(response)
            $q.reject(response)
          when 502
            crtHttpModals.showServersOfflineModal(response)['finally'](-> $window.location.reload())
            $q.reject(response)
          else
            crtHttpModals.showInternalErrorModal(response)
            $q.reject(response)
      notify: (response) ->
        return
    })

  # credentials -> void
  completeLogin = (creds) ->
    crtLog.debug('crtAuth.completeLogin', creds)
    setCredentials(creds)
    return

  # -> promiseOf(null)
  logout = ->
    # crtLog.debug('crtAuth.logout')
    crtHttp.post("#{crtConfig.api.rootUrl}/auth/v1/logout", { token: cachedToken() }, crtHttp.ignoreHandlers).then ->
      clearCredentials()
      null

  refreshCredentials = () ->
    # crtLog.debug('crtAuth.restoreIdentity')
    crtHttp.get("#{crtConfig.api.rootUrl}/auth/v1/#{cachedToken()}").then (creds) ->
      setCredentials(creds)

  changeIdentity = (loginAs) ->
    # crtLog.debug('crtAuth.changeIdentity', email)
    crtHttp.post("#{crtConfig.api.rootUrl}/auth/v1/change-identity", { loginAs }).then (creds) ->
      setCredentials(creds, true)

  restoreIdentity = (email) ->
    # crtLog.debug('crtAuth.restoreIdentity')
    crtHttp.post("#{crtConfig.api.rootUrl}/auth/v1/logout", { token: cachedToken() }).then ->
      restoreCredentials()

  # string [boolean] -> promiseOf(checkedOf(unit))
  forgotPassword = (email) ->
    # crtLog.debug('crtAuth.forgotPassword', email)
    crtHttp.post("#{crtConfig.api.rootUrl}/auth/v1/forgot-password", { email })

  # string -> promiseOf(checkedOf(unit))
  welcomeEmail = (email, workspace = undefined) ->
    # crtLog.debug('crtAuth.welcomeEmail', email)
    crtHttp.post("#{crtConfig.api.rootUrl}/auth/v1/welcome-email", { email, workspace })

  # string -> promiseOf(PasswordTokenResult)
  checkPasswordToken = (token) ->
    crtHttp.get("#{crtConfig.api.rootUrl}/auth/v1/check-token/#{token}")

  # string string -> promiseOf(checkedOf(unit))
  resetPassword = (token, password) ->
    # crtLog.debug('crtAuth.resetPassword', token, if password then "<pwd>" else null)
    crtHttp.post("#{crtConfig.api.rootUrl}/auth/v1/reset-password", { token, password })

  isSuperuser = (roles = _roles()) ->
    # Can't implement this in terms of hasRole - leads to infinite recursion:
    _.contains(roles, "superuser")

  isRealSuperuser = (roles = _realRoles()) ->
    # Can't implement this in terms of hasRole - leads to infinite recursion:
    _.contains(roles, "superuser")

  hasRole = (role, roles = _roles()) ->
    if isSuperuser(roles) || _.contains(roles, role) then true else false

  _hasRolePrefix = (prefix, roles = _roles()) ->
    if isSuperuser(roles) || _.find(roles, (role) -> role.indexOf(prefix) == 0) then true else false

  activeWorkspaceIds = (roles = _roles()) ->
    ans = []
    for role in roles when /^active:/.test(role)
      ans.push(role.substring('active:'.length))
    # crtLog.debug('crtAuth.activeWorkspaceIds', ans)
    ans

  isRegistered = (workspaceId = crtWorkspace.currentWorkspaceId(), roles = _roles()) ->
    hasRole("registered:#{workspaceId}", roles)

  isActive = (workspaceId = crtWorkspace.currentWorkspaceId(), roles = _roles()) ->
    hasRole("active:#{workspaceId}", roles)

  isActiveMobile = (workspaceId = crtWorkspace.currentWorkspaceId(), roles = _roles()) ->
    hasRole("activeMobile:#{workspaceId}", roles)

  isActivelyRegistered = (workspaceId = crtWorkspace.currentWorkspaceId(), roles = _roles()) ->
    isRegistered(workspaceId, roles) && isActive(workspaceId, roles)

  isUserAdmin = (workspaceId = crtWorkspace.currentWorkspaceId(), roles = _roles()) ->
    hasRole("userAdmin:#{workspaceId}", roles)

  isWorkspaceAdmin = (roles = _roles()) ->
    isSuperuser(roles)

  isMapViewer = (layerId, workspaceId = crtWorkspace.currentWorkspaceId(), roles = _roles()) ->
    hasRole("mapViewer:#{workspaceId}:#{layerId}", roles)

  isSurveyViewer = (surveyType, workspaceId = crtWorkspace.currentWorkspaceId(), roles = _roles()) ->
    hasRole("surveyViewer:#{workspaceId}:#{surveyType}", roles)

  isAnySurveyViewer = (workspaceId = crtWorkspace.currentWorkspaceId(), roles = _roles()) ->
    _hasRolePrefix("surveyViewer:#{workspaceId}:", roles)

  isAnySurveyViewerAnywhere = (roles = _roles()) ->
    _hasRolePrefix("surveyViewer:", roles)

  isSurveyor = (surveyType, workspaceId = crtWorkspace.currentWorkspaceId(), roles = _roles()) ->
    hasRole("surveyor:#{workspaceId}:#{surveyType}", roles)

  isAnySurveyor = (workspaceId = crtWorkspace.currentWorkspaceId(), roles = _roles()) ->
    _hasRolePrefix("surveyor:#{workspaceId}:", roles)

  isAnySurveyorAnywhere = (roles = _roles()) ->
    _hasRolePrefix("surveyor:", roles)

  isSurveyDownloader = (surveyType, workspaceId = crtWorkspace.currentWorkspaceId(), roles = _roles()) ->
    hasRole("surveyDownloader:#{workspaceId}:#{surveyType}", roles)

  isAnySurveyDownloader = (workspaceId = crtWorkspace.currentWorkspaceId(), roles = _roles()) ->
    _hasRolePrefix("surveyDownloader:#{workspaceId}:", roles)

  isAnySurveyDownloaderAnywhere = (roles = _roles()) ->
    _hasRolePrefix("surveyDownloader:", roles)

  isSurveyAdmin = (surveyType, workspaceId = crtWorkspace.currentWorkspaceId(), roles = _roles()) ->
    hasRole("surveyAdmin:#{workspaceId}:#{surveyType}", roles)

  isAnySurveyAdmin = (workspaceId = crtWorkspace.currentWorkspaceId(), roles = _roles()) ->
    _hasRolePrefix("surveyAdmin:#{workspaceId}:", roles)

  isAnySurveyAdminAnywhere = (roles = _roles()) ->
    _hasRolePrefix("surveyAdmin:", roles)

  isWorkspaceAdmin = (roles = _roles()) ->
    hasRole("superuser", roles)

  canChangeIdentity = (credentials = _credentials) ->
    isSuperuser(credentials?.identity?.roles)

  hasChangedIdentity = () ->
    _realCredentials?

  isSurveyorOfSurvey = (survey, credentials = _credentials) ->
    survey.surveyor.userId? &&
    survey.surveyor.userId == credentials?.identity?.userId

  canCreateSurvey = (surveyType, workspaceId = crtWorkspace.currentWorkspaceId(), credentials = _credentials) ->
    if surveyType
      isSuperuser(credentials?.identity?.roles) || (
        isActivelyRegistered(workspaceId, credentials?.identity?.roles) && (
          isSurveyor(surveyType, workspaceId, credentials?.identity?.roles) ||
          isSurveyAdmin(surveyType, workspaceId, credentials?.identity?.roles)
        )
      )
    else
      false

  canListSurveys = (surveyType, workspaceId = crtWorkspace.currentWorkspaceId(), credentials = _credentials) ->
    plugin = crtSurvey.optFindPlugin(surveyType)

    switch plugin?.permissionModel
      when crtSurveyPermissionModel.RoleBasedSensitive, crtSurveyPermissionModel.RoleBased
        isSuperuser(credentials?.identity?.roles) || (
          isActivelyRegistered(workspaceId, credentials?.identity?.roles) && (
            isSurveyAdmin(surveyType, workspaceId, credentials?.identity?.roles) ||
            isSurveyViewer(surveyType, workspaceId, credentials?.identity?.roles) ||
            isSurveyor(surveyType, workspaceId, credentials?.identity?.roles)
          )
        )

      when crtSurveyPermissionModel.WorkspaceVisible, crtSurveyPermissionModel.WorkspaceDownloadable
        isSuperuser(credentials?.identity?.roles) ||
        isActivelyRegistered(workspaceId, credentials?.identity?.roles)

      else false

  canSeeSurveyOnSidebar = (surveyType, workspaceId = crtWorkspace.currentWorkspaceId(), credentials = _credentials) ->
    plugin = crtSurvey.optFindPlugin(surveyType)

    switch plugin?.permissionModel
      when crtSurveyPermissionModel.RoleBasedSensitive, crtSurveyPermissionModel.RoleBased, crtSurveyPermissionModel.WorkspaceVisible, crtSurveyPermissionModel.WorkspaceDownloadable
        isSuperuser(credentials?.identity?.roles) || (
          isActivelyRegistered(workspaceId, credentials?.identity?.roles) && (
            isSurveyAdmin(surveyType, workspaceId, credentials?.identity?.roles) ||
            isSurveyViewer(surveyType, workspaceId, credentials?.identity?.roles) ||
            isSurveyor(surveyType, workspaceId, credentials?.identity?.roles)
          )
        )

      else false

  canDownloadSurveys = (surveyType, credentials = _credentials) ->
    plugin = crtSurvey.optFindPlugin(surveyType)

    switch plugin?.permissionModel
      when crtSurveyPermissionModel.RoleBasedSensitive, crtSurveyPermissionModel.RoleBased, crtSurveyPermissionModel.WorkspaceVisible
        isSuperuser(credentials?.identity?.roles) || (
          isActivelyRegistered(workspaceId, credentials?.identity?.roles) && (
            isSurveyAdmin(surveyType, workspaceId, credentials?.identity?.roles) ||
            isSurveyDownloader(surveyType, workspaceId, credentials?.identity?.roles)
          )
        )

      when crtSurveyPermissionModel.WorkspaceDownloadable
        isSuperuser(credentials?.identity?.roles) ||
        isActivelyRegistered(workspaceId, credentials?.identity?.roles)

      else false

  canViewSurvey = (survey, credentials = _credentials) ->
    plugin = crtSurvey.optFindPlugin(survey.type)
    workspaceId  = survey.workspaceId

    switch plugin?.permissionModel
      when crtSurveyPermissionModel.RoleBasedSensitive
        isSuperuser(credentials?.identity?.roles) || (
          isActivelyRegistered(workspaceId, credentials?.identity?.roles) && (
            isSurveyAdmin(survey.type, workspaceId, credentials?.identity?.roles) || (
              isSurveyorOfSurvey(survey, credentials) && (
                isSurveyViewer(survey.type, workspaceId, credentials?.identity?.roles) ||
                isSurveyor(survey.type, workspaceId, credentials?.identity?.roles)
              )
            )
          )
        )

      when crtSurveyPermissionModel.RoleBased
        switch plugin.collaborationModel
          when crtSurveyCollaborationModel.CrossWorkspace
            switch survey.status
              when crtSurveyStatus.Approved
                isSuperuser(credentials?.identity?.roles) || (
                  _.some activeWorkspaceIds(credentials?.identity?.roles ? []), (workspaceId) ->
                    isActivelyRegistered(workspaceId, credentials?.identity?.roles) && (
                      isSurveyAdmin(survey.type, workspaceId, credentials?.identity?.roles) ||
                      isSurveyViewer(survey.type, workspaceId, credentials?.identity?.roles) ||
                      isSurveyor(survey.type, workspaceId, credentials?.identity?.roles)
                    )
                )

              else
                isSuperuser(credentials?.identity?.roles) || (
                  isActivelyRegistered(workspaceId, credentials?.identity?.roles) && (
                    isSurveyAdmin(survey.type, workspaceId, credentials?.identity?.roles) ||
                    isSurveyViewer(survey.type, workspaceId, credentials?.identity?.roles) ||
                    isSurveyor(survey.type, workspaceId, credentials?.identity?.roles)
                  )
                )

          when crtSurveyCollaborationModel.SingleWorkspace
            isSuperuser(credentials?.identity?.roles) || (
              isActivelyRegistered(workspaceId, credentials?.identity?.roles) && (
                isSurveyAdmin(survey.type, workspaceId, credentials?.identity?.roles) ||
                isSurveyViewer(survey.type, workspaceId, credentials?.identity?.roles) ||
                isSurveyor(survey.type, workspaceId, credentials?.identity?.roles)
              )
            )

          else false

      when crtSurveyPermissionModel.WorkspaceVisible, crtSurveyPermissionModel.WorkspaceDownloadable
        switch plugin.collaborationModel
          when crtSurveyCollaborationModel.CrossWorkspace
            switch survey.status
              when crtSurveyStatus.Approved
                isSuperuser(credentials?.identity?.roles) ||
                isActivelyRegistered(workspaceId, credentials?.identity?.roles) || (
                  _.some activeWorkspaceIds(credentials?.identity?.roles ? []), (workspaceId) ->
                    isActivelyRegistered(workspaceId, credentials?.identity?.roles) && (
                      isSurveyAdmin(survey.type, workspaceId, credentials?.identity?.roles) ||
                      isSurveyViewer(survey.type, workspaceId, credentials?.identity?.roles) ||
                      isSurveyor(survey.type, workspaceId, credentials?.identity?.roles)
                    )
                )

              else
                isSuperuser(credentials?.identity?.roles) ||
                isActivelyRegistered(workspaceId, credentials?.identity?.roles)

          when crtSurveyCollaborationModel.SingleWorkspace
            isSuperuser(credentials?.identity?.roles) ||
            isActivelyRegistered(workspaceId, credentials?.identity?.roles)

          else false
      else false

  canUpdateSurveyStatus = (survey, credentials = _credentials) ->
    workspaceId  = survey.workspaceId

    switch survey.status
      when crtSurveyStatus.Approved, crtSurveyStatus.Rejected
        isSuperuser(credentials?.identity?.roles) || (
          isActivelyRegistered(workspaceId, credentials?.identity?.roles) && (
            isSurveyAdmin(survey.type, workspaceId, credentials?.identity?.roles)
          )
        )

      else
        isSuperuser(credentials?.identity?.roles) || (
          isActivelyRegistered(workspaceId, credentials?.identity?.roles) && (
            isSurveyAdmin(survey.type, workspaceId, credentials?.identity?.roles) || (
              isSurveyorOfSurvey(survey, credentials) && (
                isSurveyor(survey.type, workspaceId, credentials?.identity?.roles)
              )
            )
          )
        )

  canUpdateSurveyData = (survey, credentials = _credentials) ->
    workspaceId = survey.workspaceId

    switch survey.status
      when crtSurveyStatus.Approved, crtSurveyStatus.Rejected
        false

      else
        isSuperuser(credentials?.identity?.roles) || (
          isActivelyRegistered(workspaceId, credentials?.identity?.roles) && (
            isSurveyAdmin(survey.type, workspaceId, credentials?.identity?.roles) || (
              isSurveyorOfSurvey(survey, credentials) && (
                isSurveyor(survey.type, workspaceId, credentials?.identity?.roles)
              )
            )
          )
        )

  canDeleteSurvey = (survey, credentials = _credentials) ->
    canUpdateSurveyData(survey, _credentials)

  canViewMapLayer = (layerId, workspaceId = crtWorkspace.currentWorkspaceId(), credentials = _credentials) ->
    plugin = crtLayer.optFindPlugin(layerId)

    ans = switch plugin?.permissionModel
      when crtMapPermissionModel.RoleBased then isSuperuser(credentials?.identity?.roles) || isMapViewer(layerId, workspaceId, credentials?.identity?.roles)
      when crtMapPermissionModel.Workspace then true
      when crtMapPermissionModel.Active    then true
      when crtMapPermissionModel.Public    then true
      else                                      false

    # crtLog.debug('crtAuth.canViewMapLayer', { layerId, workspaceId, credentials, plugin, ans })

    ans

  canSeeMapLayerOnSidebar = (layerId, workspaceId = crtWorkspace.currentWorkspaceId(), credentials = _credentials) ->
    canViewMapLayer(layerId, workspaceId, credentials)

  canCreateUser = (credentials = _credentials) ->
    isUserAdmin(undefined, credentials?.identity?.roles)

  canUpdateUser = (user, credentials = _credentials) ->
    a = isUserAdmin(undefined, credentials?.identity?.roles)
    b = credentials?.identity?.userId == user.id
    a || b

  canDeleteUser = (user, credentials = _credentials) ->
    a = isUserAdmin(undefined, credentials?.identity?.roles)
    b = credentials?.identity?.userId == user.id
    a || b

  canListInvitations = (credentials = _credentials) ->
    isUserAdmin(undefined, credentials?.identity?.roles)

  canCreateInvitation = (credentials = _credentials) ->
    isUserAdmin(undefined, credentials?.identity?.roles)

  canUpdateInvitation = (user, credentials = _credentials) ->
    # Can't update invitations after they've been created:
    false # isUserAdmin(undefined, credentials?.identity?.roles)

  canDeleteInvitation = (user, credentials = _credentials) ->
    isUserAdmin(undefined, credentials?.identity?.roles)

  canCreateSignupCodes = (credentials = _credentials) ->
    isUserAdmin(undefined, credentials?.identity?.roles)

  canUpdateWorkspace = (workspace, credentials = _credentials) ->
    isWorkspaceAdmin(credentials?.identity?.roles)

  # Private function to string requireCredentials() together with isPermissionFoo() methods:
  #     requireCredentials().then(checkHasRole(isPermissionFoo))
  #
  # (arrayOf(role) -> boolean) [boolean] -> promise(credentials)
  checkHasRole = (credentials, hasRole) ->
    roles = credentials?.identity?.roles
    # crtLog.debug("crtAuth.checkHasRole", credentials, roles, hasRole)
    if hasRole(roles)
      credentials
    else
      $q.reject("You do not have the required permissions.")

  checkSuperuser = (credentials) ->
    checkHasRole(credentials, isSuperuser)

  checkRegistered = (credentials, workspaceId = undefined) ->
    checkHasRole(credentials, (roles) -> isRegistered(workspaceId, roles))

  checkActive = (credentials, workspaceId = undefined) ->
    checkHasRole(credentials, (roles) -> isActive(workspaceId, roles))

  checkSurveyor = (credentials, surveyType) ->
    checkHasRole(credentials, (roles) -> isSurveyor(surveyType, undefined, roles))

  checkSurveyAdmin = (credentials, surveyType) ->
    checkHasRole(credentials, (roles) -> isSurveyAdmin(surveyType, undefined, roles))

  checkUserAdmin = (credentials, workspaceId = undefined) ->
    checkHasRole(credentials, (roles) -> isUserAdmin(workspaceId, roles))

  checkWorkspaceAdmin = (credentials) ->
    checkHasRole(credentials, isWorkspaceAdmin)

  convertRolesForward = (roles, permissive = true) ->
    crtHttp.post("#{crtConfig.api.rootUrl}/legacy/v1/role/forward?permissive=#{permissive}", roles)

  convertRolesReverse = (roles) ->
    crtHttp.post("#{crtConfig.api.rootUrl}/legacy/v1/role/reverse", roles)

  return {
    credentials
    realCredentials
    authError
    requireCredentials
    optionalCredentials
    validateAnonymousSignup
    validateWorkshopSignup
    submitSignup
    validateLogin
    submitLogin
    completeLogin
    logout
    refreshCredentials
    changeIdentity
    restoreIdentity
    forgotPassword
    welcomeEmail
    checkPasswordToken
    resetPassword
    isSuperuser
    isRealSuperuser
    hasRole
    activeWorkspaceIds
    isLoggedIn
    isRegistered
    isActive
    isActiveMobile
    isUserAdmin
    isWorkspaceAdmin
    isMapViewer
    isSurveyViewer
    isAnySurveyViewer
    isAnySurveyViewerAnywhere
    isSurveyor
    isAnySurveyor
    isAnySurveyorAnywhere
    isSurveyDownloader
    isAnySurveyDownloader
    isAnySurveyDownloaderAnywhere
    isSurveyAdmin
    isAnySurveyAdmin
    isAnySurveyAdminAnywhere
    isWorkspaceAdmin
    canChangeIdentity
    hasChangedIdentity
    canListSurveys
    canSeeSurveyOnSidebar
    canCreateSurvey
    canViewSurvey
    canDownloadSurveys
    canUpdateSurveyStatus
    canUpdateSurveyData
    canDeleteSurvey
    canViewMapLayer
    canSeeMapLayerOnSidebar
    canCreateUser
    canUpdateUser
    canDeleteUser
    canListInvitations
    canCreateInvitation
    canUpdateInvitation
    canDeleteInvitation
    canCreateSignupCodes
    canUpdateWorkspace
    checkSuperuser
    checkRegistered
    checkActive
    checkSurveyor
    checkSurveyAdmin
    checkUserAdmin
    checkWorkspaceAdmin
    convertRolesForward
    convertRolesReverse
  }
